import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const dcUserParamsSchema = object({
  userId: stringToNumber()
})
